import script from "./DishDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DishDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./DishDetailDialog.vue?vue&type=style&index=0&id=d0e64a9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0e64a9e"]])

export default __exports__